export default __webpack_public_path__ + "static/media/alejandro-loguercio-orchester-2.01fbbb8f.jpg";